/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Desc_PausedInputs */

const en_wb_desc_paused = /** @type {(inputs: Wb_Desc_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The work stays here. Reset the example to try again.`)
};

const lv_wb_desc_paused = /** @type {(inputs: Wb_Desc_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darbs paliek šeit. Atiestatiet piemēru, lai mēģinātu vēlreiz.`)
};

/**
* | output |
* | --- |
* | "The work stays here. Reset the example to try again." |
*
* @param {Wb_Desc_PausedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_desc_paused = /** @type {((inputs?: Wb_Desc_PausedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Desc_PausedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_desc_paused(inputs)
	return en_wb_desc_paused(inputs)
});